import { render, staticRenderFns } from "./area.vue?vue&type=template&id=1d55dc75&scoped=true&"
import script from "./area.vue?vue&type=script&lang=js&"
export * from "./area.vue?vue&type=script&lang=js&"
import style0 from "./area.vue?vue&type=style&index=0&id=1d55dc75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55dc75",
  null
  
)

export default component.exports